import { useFormContext, useWatch } from "react-hook-form";
import ItemExtraDto from "../../../models/ItemExtraDto";
import ItemOptionGroupDto from "../../../models/ItemOptionGroupDto"
import { Box, Typography } from "@mui/material";
import { useTranslation } from 'react-i18next';
import { useMemo } from "react";
import { ItemExtraForm } from "../../menuCard/extras/ItemExtras";
import { useRestaurantData } from "../../../provider/RestaurantDataContext";
import { currencyFormat } from "../../../utils/Utils";

interface ItemOptionPriceCalculatorProps {
    optionGroups: ItemOptionGroupDto[];
    itemExtras: ItemExtraDto[];
    itemPrice: number;
}

export default function ItemOptionPriceCalculator({ optionGroups, itemExtras, itemPrice }: ItemOptionPriceCalculatorProps) {
    const { t } = useTranslation();
    const { control, getValues } = useFormContext();
    const { restaurantData: { currency: { detail } } } = useRestaurantData();
    const options: number[] = useWatch({ name: 'options', control, defaultValue: [] });
    const extras: ItemExtraForm[] = useWatch({ name: 'itemExtras', control, defaultValue: [] });
    //console.log('values', options, extras);

    const calculatedPrice = useMemo(() => {
        let price = itemPrice;
        Array.from(Object.keys(options)).forEach(optionGroupId => {
            const optionGroup = optionGroups.filter(optionGroup => Number.parseInt(optionGroupId) === optionGroup.id)[0];
            const selectedOptionIdFromGroup = getValues('options.' + optionGroupId);
            //console.log('testing', optionGroupId, optionGroup, selectedOptionIdFromGroup)
            if (!optionGroup || !selectedOptionIdFromGroup) return;
            //console.log('option', (itemPrice + optionGroup.itemOptions.filter(option => option.id === Number.parseInt(selectedOptionIdFromGroup))[0].price));
            price += optionGroup.itemOptions.filter(option => option.id === Number.parseInt(selectedOptionIdFromGroup))[0].price;
        })
        Array.from(Object.keys(extras)).forEach(itemExtraId => {
            const itemExtra = itemExtras.filter(extra => extra.id === Number.parseInt(itemExtraId))[0];
            const amount = Number.parseInt(getValues('itemExtras.' + itemExtraId + '.amount'));
            price += amount * itemExtra.price;
        });
        return price;
    }, [options, extras, itemPrice, optionGroups, getValues, itemExtras]);

    return (
        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
            <Typography sx={{ fontWeight: 'bold' }}>{t("optionsPrice") + ":"}</Typography>
            <Typography sx={{ fontWeight: 'bold' }}>{currencyFormat(calculatedPrice)}{detail}</Typography>
        </Box>
    )
}